import { cn } from "@/lib/utils";

// Official MYTHIVA™ horizontal wordmark. Do not recreate/redraw/recolour.
// In dark mode it reverses to a clean white lockup purely for legibility on
// dark surfaces (a permitted responsive-rendering accommodation).
export function OrbitLogo({ className, size = 28 }) {
  return (
    <img
      src="/mythiva-logo.png"
      alt="MYTHIVA™ by Mythos India Studios"
      style={{ height: size, width: "auto" }}
      className={cn("block select-none dark:brightness-0 dark:invert", className)}
      draggable="false"
      data-testid="mythiva-logo"
    />
  );
}

// Kept the historical export name so existing imports keep working.
export function OrbitWordmark({ className, size = 26 }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="mythiva-wordmark">
      <OrbitLogo size={size} />
      <span className="border-l border-border/70 pl-2.5 font-display text-sm font-semibold uppercase tracking-[0.22em] text-foreground">
        ORBIT
      </span>
    </div>
  );
}
